import {
  Button,
  Table,
  Space,
  Form,
  Popconfirm,
  Row,
  Typography,
  Col,
} from "antd";
import React, {useEffect, useState} from "react";
import {EditableCell, EditableRow} from "./EditTable";
import Icons from "assets/icons";
import {ColumnTypes} from "types/models/column-table-edit";
import "./TableInputAdd.scss";
import {
  convertDateStringToDateDayjs,
  convertIosStringToDateDayjs,
  formatDateToStringUnix,
  formatToCurrencyTypeToFixed,
  isValuable,
  randomId,
} from "helper/common";
import {shoppingService} from "api";
import {RecycleSVG} from "assets";
import {toArray} from "@amcharts/amcharts5/.internal/core/util/Array";
import dayjs from "dayjs";
import {Notification} from "components/common";

const TableInputAddThanhToan = ({
  column,
  isCheckbox,
  disabled,
  idSelectedItem,
  ...rest
}: any): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const name = "lichSuThanhToanDNTTs";
  const [data, setData] = useState<any[]>([]);
  const [soLuongConLai, setSoLuongConLai] = useState<any>();
  const [thanhTienConLai, setThanhTienConLai] = useState<any>();
  const [tongSoLuong, setTongSoLuong] = useState<any>();
  const [tongThanhTien, setTongThanhTien] = useState<any>();
  const addRowTb1 = () => {
    const newData = {
      key: randomId(),
    };
    setData([...data, newData]);
  };
  const getData = async idSelectedItem => {
    try {
      setIsLoading(true);
      const res = await shoppingService.getListTheoDoiThanhToan(idSelectedItem);
      const listLichSu = toArray(res?.lichSuThanhToanDNTTs).map(e => ({
        ...e,
        ngayThanhToan: convertDateStringToDateDayjs(e?.ngayThanhToan, true),
        key: randomId(),
      }));
      form.setFieldValue("lichSuThanhToanDNTTs", listLichSu);
      setData(listLichSu);
      setSoLuongConLai(res?.soLuongConLai);
      setThanhTienConLai(res?.thanhTienConLai);
      setTongSoLuong(res?.tongSoLuong);
      setTongThanhTien(res?.tongThanhTien);
    } catch (error) {
      form.setFieldValue("lichSuThanhToanDNTTs", []);

      setData([]);
      setSoLuongConLai(0);
      setThanhTienConLai(0);
      setTongSoLuong(0);
      setTongThanhTien(0);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    console.log(idSelectedItem);
    if (isValuable(idSelectedItem)) {
      getData(idSelectedItem);
    }
  }, [idSelectedItem]);
  column.some((item: any) => {
    if (item.key == "action") {
      item.title = (
        <Button
          disabled={disabled}
          type="primary"
          onClick={addRowTb1}
          icon={<Icons.add />}
          size="small"
        />
      );
      item.fixed = "right";
      item.render = (_: any, record: any, index: number) => (
        <Space>
          {!record?.id && (
            <Button
              icon={<Icons.save />}
              size="middle"
              type="primary"
              onClick={() => {
                handleSave(form.getFieldValue(["lichSuThanhToanDNTTs", index]));
              }}
            ></Button>
          )}

          {record?.id && (
            <Popconfirm
              className="danger-confirm"
              title={"Bạn có xác nhận xóa"}
              onConfirm={() => {
                handleDelete(record);
              }}
            >
              <Button type="text" icon={<RecycleSVG />} />
            </Popconfirm>
          )}

          {/* <Button
            disabled={disabled}
            type="primary"
            danger
            onClick={() => {
              removeRowTb1(record?.key);
            }}
            icon={<Icons.sub />}
            size="small"
          /> */}
        </Space>
      );
    }
  });

  const removeRowTb1 = (key: string) => {
    const previousFormList = form.getFieldValue([name]);

    const indexRemove = data.findIndex((e: any) => e?.key == key);
    const afterFormList = previousFormList.filter(
      (e: any, index: number) => index != indexRemove
    );
    form.setFieldValue([name], afterFormList);

    const newData = data.filter((item: any) => item.key != key);
    setData([...newData]);
  };

  const handleSave = async data => {
    try {
      setIsLoading(true);
      const formatData = {
        ...data,
        ngayThanhToan: formatDateToStringUnix(data?.ngayThanhToan),
        idChiTietPhieu: idSelectedItem,
      };
      await shoppingService.createTheoDoiThanhToan(formatData);
      Notification("success", "Đã lưu thành công");
      getData(idSelectedItem);
    } catch (error) {
      Notification("error", error?.response?.data ?? "Đã có lỗi khi lưu");
    } finally {
      setIsLoading(false);
    }
  };
  const handleDelete = async record => {
    try {
      setIsLoading(true);
      await shoppingService.deleteTheoDoiThanhToan(record?.id);
      getData(idSelectedItem);
      // removeRowTb1(record?.key);
      Notification("success", "Đã xóa thành công");
    } catch (error) {
      Notification("error", error?.response?.data ?? "Đã có lỗi khi lưu");
    } finally {
      setIsLoading(false);
    }
  };
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const columns = column
    .filter((e: any) => e.show == true)
    .map((col: any) => {
      return {
        ...col,
        onCell: (record: any, index: number) => ({
          record: data[index],
          selected: col.selected,
          dataIndex: col.dataIndex,
          title: col.title,
          options: col.options,
          onChange: col.onChange,
          index: index,
          type: col.type,
          disabled: col.disabled ?? isValuable(record?.id),
          value: col.value,
          name: name,
          form: form,
          initRules: col.rules,
          autoFocus: col.autoFocus,
          fields: col.fields,
          hidden: col.hidden,
          ...col,
        }),
      };
    });

  return (
    <div className="table-prescription">
      <Form form={form}>
        <Table
          loading={isLoading}
          rowKey={record => record.key}
          components={components}
          rowClassName={"editable-row-2"}
          bordered
          dataSource={data}
          columns={columns as ColumnTypes}
          {...rest}
          pagination={false}
        />
      </Form>
      <Row>
        <Col span={12}>
          <div style={{display: "flex", justifyContent: "center"}}>
            <div style={{width: "400px", wordWrap: "break-word"}}>
              <Space direction="vertical" size={12} style={{width: "100%"}}>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text strong>Tổng tiền (VNĐ):</Typography.Text>
                  </Col>
                  <Col>
                    <Typography.Text strong>
                      {formatToCurrencyTypeToFixed(tongThanhTien)}
                    </Typography.Text>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text strong>Tổng số lượng: </Typography.Text>
                  </Col>
                  <Col>
                    {" "}
                    <Typography.Text strong>{tongSoLuong}</Typography.Text>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text strong>
                      Tiền còn lại (VNĐ):{" "}
                    </Typography.Text>
                  </Col>
                  <Col>
                    <Typography.Text strong>
                      {formatToCurrencyTypeToFixed(thanhTienConLai)}
                    </Typography.Text>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text strong>Số lượng còn lại: </Typography.Text>
                  </Col>
                  <Col>
                    <Typography.Text strong>{soLuongConLai}</Typography.Text>
                  </Col>
                </Row>
              </Space>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TableInputAddThanhToan;
